/**
 * @file plugins/childDemographics.js
 * @author Jake Stark
 * @desc Child Demographics report plugin

*/

/**
 * @module plugins/childDemographics
 * @desc Child Demographics report plugin
 */

define('plugins/summaryReport',["text!pluginTemplates/kindergartenCharacteristics_table.html!strip", 
        "text!pluginTemplates/kindergartenCharacteristics2_table.html!strip", 
        "text!pluginTemplates/kindergartenCharacteristics3_table.html!strip",        
        "text!pluginTemplates/kindergartenCharacteristics4_table.html!strip",        
        "text!pluginTemplates/kindergartenCharacteristics5_table.html!strip",
        "models", "cardboard/models", "cardboard/collections", "cardboard/pluginPieces"],
       function (kinderCharTemplate, kinderCharTemplate2, kinderCharTemplate3, kinderCharTemplate4,
                  kinderCharTemplate5, ECLDSModels, CardboardModels, CardboardCollections, PluginPieces) {

    console.log("MODULE: childDemographics");

    var exports = {

        // other names by which this plugin is known. this exists for
        // WebFOCUS shim compatibility
        //aliases: ["demographic", "demographics"],
        options: {
            //noDefaultOrg: true,
            orgDetailPane: false,
            noMapSearch: true,
            noOrgSearch: false,
            forcedSummaryFilters: ["FISCAL_YEAR", "RACE_ETHTYPE"],
            definitionsECLDS: true
        },

        // the options available to these filters will be populated
        // from the database, via the below data sources
        filters: {
            // no filters!
        },

        // each of these is the configuration that gets passed to a
        // DataBoxPaneView.
        panes: [
            {
                title: "Kindergarten Characteristics by Early Care and Education Participation Status",
                explanationText: "<p>This table summarizes select characteristics as well as early care and education experiences of public school kindergartners.</p>",
                openByDefault: true,

                views: [
                    {
                        type: "template",
                        template: "<p> This table summarizes select characteristics as well as early care and education experiences of public school kindergartners, and includes information about their participation in the <a href='#' class='click1'>early care and education programs included in the ECLDS</a>. <span id='tip1' class='tooltip tip1' role='tooltip' > Early care and education program data available in ECLDS includes the Child Care Assistance Program (CCAP), Early Childhood Family Education (ECFE), Early Childhood Special Education (ECSE) and MN District Preschool</span>The data available here are also represented in chart format in other Kindergarten reports in the ECLDS.</p><p>Because ECFE serves children from birth to Kindergarten entrance, and ECFE data begins with the 2013-14 school year, ECLDS most fully represents ECFE participation in Kindergarten reports beginning with the 2019-20 school year.</p><p>As of June 2021, Voluntary Prekindergarten (VPK) and School Readiness Plus (SRP) data are included in the MN District Preschool data provided by MDE. School Readiness data begin with the 2013-2014 school year; VPK data begin with the 2016-2017 school year; SRP data begin with the 2017-2018 school year.</p><p><b>Go directly to:</b><br/><a href='#' id='CCAP'>Child Care Assistance Program</a><br/><a href='#' id='ECFE'>Early Childhood Family Education</a><br/><a href='#' id='ECSE'>Early Childhood Special Education</a><br/><a href='#' id='PRE'>MN District Preschool</a></p>",
                        dataSourceName: "data",
                        dataPath: "dataSets.All"
                    },
                    {
                        type: "template",
                        dataSourceName: "data",
                        dataSetPath: "dataSets.All",
                        template: kinderCharTemplate,
                        errorConditions: [PluginPieces.standardErrorCondition]
                    },
                    {
                        type: "template",
                        template: "<h2 id='ccapAnchor' style='background-color: #d9d9d9; margin-top:3px; text-align:center'>Child Care Assistance Program</h2>",
                        dataSourceName: "data",
                        dataPath: "dataSets.CCAP"
                    },
                    {
                        type: "template",
                        dataSourceName: "data",
                        dataSetPath: "dataSets.CCAP",
                        template: kinderCharTemplate2,
                        errorConditions: [PluginPieces.standardErrorCondition]
                    },
                    {
                        type: "template",
                        template: "<h2 id='ecfeAnchor' style='background-color: #d9d9d9; margin-top:3px; text-align:center'>Early Childhood Family Education</h2>",
                        dataSourceName: "data",
                        dataPath: "dataSets.ECFE"
                    },
                    {
                        type: "template",
                        dataSourceName: "data",
                        dataSetPath: "dataSets.ECFE",
                        template: kinderCharTemplate3,
                        errorConditions: [PluginPieces.standardErrorCondition]
                    },
                    {
                        type: "template",
                        template: "<h2 id='ecseAnchor' style='background-color: #d9d9d9; margin-top:3px; text-align:center'>Early Childhood Special Education</h2>",
                        dataSourceName: "data",
                        dataPath: "dataSets.ECSE"
                    },
                    {
                        type: "template",
                        dataSourceName: "data",
                        dataSetPath: "dataSets.ECSE",
                        template: kinderCharTemplate4,
                        errorConditions: [PluginPieces.standardErrorCondition]
                    },
                    {
                        type: "template",
                        template: "<h2 id='preAnchor' style='background-color: #d9d9d9; margin-top:3px; text-align:center'>MN District Preschool",
                        dataSourceName: "data",
                        dataPath: "dataSets.MNDISTRICTPRE_SCHOOL"
                    },
                    {
                        type: "template",
                        dataSourceName: "data",
                        dataSetPath: "dataSets.MNDISTRICTPRE_SCHOOL",
                        template: kinderCharTemplate5,
                        errorConditions: [PluginPieces.standardErrorCondition]
                    }
                ]
            }
        ],

        filterSources: {
            orgs: {
                modelType: ECLDSModels.ECLDSOrgList,
                //url: "/data/state.json",
                url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_orgid_childdemographics.fex",
                noViewParams: true,
                enabled: true
            },
            
            filters: {
                modelType: CardboardModels.FilterProducer,
                filterSources: ["filterForReport"],
                urls: {
                    filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_summaryreport_EcoDevRegion.fex"
                },
                enabled: true,
                noViewParams: false
            },
            filters2: {
                url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_fiscal_year.fex",
                enabled: true,
                modelType: CardboardModels.FilterData
            },
            filters3: {
                modelType: CardboardModels.FilterProducer,
                filterSources: ["filterForReport"],
   
                urls: {

                    filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_kgsummary.fex"
                },

                enabled: true,
                noViewParams: false
            }

            
        },

        dataSources: {
            data: {
                modelType: CardboardModels.Model,
                //url:"/data/tempChildDemo.json",
                url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_summaryreport.fex",
                yearPath: "meta.fiscalYear", // where to look in the JSON for the year
                //	defaultParams: {
                //		orgId: 999999000,
                //      COHORTID: 2014
                //	},
                enabled: true,
                errorConditions: [PluginPieces.standardErrorCondition]
            }
        }
    };

    return exports;
});
